/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type PeopleProfilesEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const peopleProfilesEntrypoint: EntryPoint<PeopleProfilesEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<PeopleProfilesEntrypointComponent>(
			/* webpackChunkName: "async-people-profiles-entrypoint" */ './PeopleProfiles.tsx',
		),
		getPreloadProps: () => ({}),
	});
